/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NewsletterDto } from '../../models/newsletter-dto';

export interface GetNewsletter$Params {
}

export function getNewsletter(http: HttpClient, rootUrl: string, params?: GetNewsletter$Params, context?: HttpContext): Observable<StrictHttpResponse<NewsletterDto>> {
  const rb = new RequestBuilder(rootUrl, getNewsletter.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NewsletterDto>;
    })
  );
}

getNewsletter.PATH = '/newsletter';
